define(
({
  "select_shipping_method": "Vyberte spôsob doručenia"
})
);
